import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-12 col-md-6" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "col-sm-12 col-md-6" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "fs-22 mb-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "fs-14 mb-2" }, "Scegli uno slot", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("template", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-22 mb-2" }, "Seleziona un giorno dal calendario")
], -1)
const _hoisted_9 = { class: "list" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calendar = _resolveComponent("calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_calendar, {
        class: "month smallCalendar",
        "show-mode-changer": false,
        "scroll-to-hour": false,
        "start-mode": 'month'
      }, {
        default: _withCtx((calData) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calData.days, (day, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["calendarDay", day.classes]),
              key: i
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$filters.date(day.date, 'DD')), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["box pointer", { 'bg-green': _ctx.getFasceOfDay(day).length > 0}]),
                onClick: ($event: any) => (_ctx.selectDate(day))
              }, _toDisplayString(_ctx.getFasceOfDay(day).length) + " slot disponibili ", 11, _hoisted_3)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.value.date)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, "Giorno selezionato: " + _toDisplayString(_ctx.$filters.date(_ctx.value.date)), 1),
              _hoisted_7
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOrari, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["listItem", { 'selected': _ctx.value.fasciaOraria.from == item.from && _ctx.value.fasciaOraria.to == item.to }]),
              key: i,
              onClick: ($event: any) => (_ctx.setFascia(item))
            }, " Dalle " + _toDisplayString(_ctx.$filters.timespan(item.from)) + " alle " + _toDisplayString(_ctx.$filters.timespan(item.to)), 11, _hoisted_10))
          }), 128))
        ])
      ])
    ])
  ]))
}